"use client";

import { ChatBot } from "@/features/chat";
import { SearchFilters } from "@/features/search";
import {
  useInterimStateManager,
  useRag,
} from "@/state/globalStore";
import LoadingState from "@/shared/ui/LoadingState";
import WithDrawerOpen from "@/shared/ui/gestures/WithDrawerOpen";

export default function PrivateUtilityDrawers() {
  const { interimState, setInterimState, resetInterimState } =
    useInterimStateManager();
  const { loadingKnowledge, preparingChat } = useRag();

  return (
    <>
      <WithDrawerOpen
        title="Search Filters"
        isOpen={interimState.search_filters?.isOpen ?? false}
        onOpenChangeAction={(isOpen) => {
          setInterimState("search_filters", { isOpen });
        }}
        onCloseAction={() => {
          resetInterimState("search_filters");
        }}
      >
        <SearchFilters />
      </WithDrawerOpen>

      <WithDrawerOpen
        title="Chat with MoveOn Profiler"
        isOpen={interimState.open_chat?.isOpen ?? false}
        onOpenChangeAction={(isOpen) => {
          setInterimState("open_chat", { isOpen });
        }}
        onCloseAction={() => {
          resetInterimState("open_chat");
        }}
      >
        {preparingChat ? (
          <LoadingState
            message={
              loadingKnowledge
                ? "Loading profile selection..."
                : "Preparing chat..."
            }
          />
        ) : (
          <ChatBot />
        )}
      </WithDrawerOpen>
    </>
  );
}
